import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn, IconInput } from '@massilia/ui';
import { useStore } from '@tanstack/react-form';
import { useFieldContext } from '../hooks/use-app-form.js';
import { FieldDisplayValue } from './field-display-value';
import { FieldError } from './field-error';
export default function TextField({ containerClassName, errorAsString = false, onDisplayClick, renderType = 'edit', ...props }) {
    const field = useFieldContext();
    const errors = useStore(field.store, (state) => state.meta.errors);
    if (renderType === 'display') {
        return (_jsx(FieldDisplayValue, { className: containerClassName, label: props.label, onClick: onDisplayClick, placeholder: props.placeholder, value: field.state.value ?? '' }));
    }
    return (_jsxs("div", { className: cn('flex flex-1 flex-col gap-1', containerClassName), children: [_jsx(IconInput, { "aria-invalid": errors.length > 0, onBlur: field.handleBlur, onChange: (e) => {
                    if (props.optional && e.target.value === '') {
                        field.handleChange(null);
                        return;
                    }
                    field.handleChange(e.target.value);
                }, value: field.state.value ?? '', ...props }), _jsx(FieldError, { asString: errorAsString, errors: errors })] }));
}
